import { render, staticRenderFns } from "./TabReservations.vue?vue&type=template&id=4fa44adc&"
import script from "./TabReservations.vue?vue&type=script&lang=ts&"
export * from "./TabReservations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4fa44adc', component.options)
    } else {
      api.reload('4fa44adc', component.options)
    }
    module.hot.accept("./TabReservations.vue?vue&type=template&id=4fa44adc&", function () {
      api.rerender('4fa44adc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/NDV/TabsModals/Reservations/TabReservations.vue"
export default component.exports